import { render, staticRenderFns } from "./ContentFilterSelect.vue?vue&type=template&id=135b8a4d&scoped=true&"
import script from "./ContentFilterSelect.vue?vue&type=script&lang=js&"
export * from "./ContentFilterSelect.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilterSelect.vue?vue&type=style&index=0&id=135b8a4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b8a4d",
  null
  
)

export default component.exports